<template>
  <div class="panel-body">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>{{ formText }}</v-card-text>
        <v-img v-bind:src="imgSrc"></v-img>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template>
      <v-form>
        <v-container>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-flex>
        </v-container>
      </v-form>
      <v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="rewards"
          :search="search"
          item-key="rewardId"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
        >
          <template slot="item" slot-scope="props">
            <tr @click="selectReward(props.item)">
              <td class="text-xs-right">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.url }}</td>
              <td class="text-xs-left">{{ props.item.createdDate }}</td>
            </tr>
          </template>
          <template slot="no-data"></template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      required: true
    }
  },
  data: () => ({
    search: '',
    imgSrc: '',
    rppItems: [
      5,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 5,
    selected: [],
    errors: [],
    dialog: false,
    headers: [
      {
        text: 'Receipt ID',
        align: 'left',
        sortable: false,
        value: 'receiptId'
      },
      { text: 'Filename', value: 'url' },
      { text: 'Created Date', value: 'createdDate' }
    ],
    rewards: []
  }),
  computed: {
    formTitle () {
      if (this.user === undefined || this.user == null) {
        return 'Reward'
      } else {
        return 'Reward for ' + this.user.quberUserName
      }
    },
    formText () {
      if (
        this.selected == null ||
        this.selected.length < 1 ||
        this.selected[0] == null
      ) {
        return 'Nothing'
      } else {
        return "Receipt: '" + this.selected[0].url + "'"
      }
    }
  },
  created () {
    this.loadReceipts()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadReceipts()
      }
    }
  },

  methods: {
    async selectReward (a) {
      this.dialog = true
      this.selected = [a]
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/document?type=USER_RECEIPT&name=${a.url}`

      var getResponse = await rh.default.getBlob(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) {
        // console.log('For URL: [' + a.url + ']')
        this.imgSrc = ''
      } else {
        this.imgSrc = URL.createObjectURL(getResponse.data)
      }
    },

    async loadReceipts () {
      if (this.user == null || this.user.userId == null || this.user.userId === '') {
        // console.log('User ID not set, unable to load rewards')
        this.rewards = []
        return
      }
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_REWARDS
      }/list-receipts?userId=${this.user.userId}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) {
        this.rewards = []
      } else {
        this.rewards = getResponse.data
      }
    },

    close () {
      this.dialog = false
    }
  }
}
</script>
<style>
</style>
